<div
    class="flash-message-container"
    [ngClass]="{ flashing: isFlashing() }"
    (click)="stopFlashing()"
    [innerHTML]="getFlashMessage()"
></div>
<ngx-loading-bar [includeSpinner]="false" [color]="'#ff3366'" [height]="'3px'"></ngx-loading-bar>
